import { cn } from '@repo/lib/cn';
import { ComponentProps } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

export default function MeetingCardSkeleton(meetingCardSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = meetingCardSkeletonProps;
  return (
    <div {...props} className={cn('border-border-primary bg-fill-primary flex gap-1 rounded-md border p-2', className)}>
      <Skeleton className={'h-11 min-h-11 w-11 min-w-11 rounded-sm'} />
      <div className={'bg-fill-secondary h-full w-0.5 min-w-0.5 rounded-xs'} />
      <div className={'flex flex-col justify-center gap-1'}>
        <Skeleton className={'h-3 w-14 rounded-sm'} />
        <Skeleton className={'h-3 w-12 rounded-sm'} />
      </div>
    </div>
  );
}
